import React from 'react';

export default function PiedPage() {
  return (
    <footer className="mt-10 border-t border-gray-200 bg-white">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-6 px-4 py-10 md:grid-cols-3">
        <div>
          <div className="text-lg font-semibold text-gray-900">shopmarega.com</div>
          <div className="mt-2 text-sm text-gray-600">
            Boutique en ligne moderne, rapide et professionnelle.
          </div>
        </div>
        <div className="text-sm text-gray-600">
          <div className="font-semibold text-gray-900">Paiements</div>
          <div className="mt-2">Carte bancaire (Stripe)</div>
          <div>Orange Money</div>
          <div>Wave</div>
        </div>
        <div className="text-sm text-gray-600">
          <div className="font-semibold text-gray-900">Support</div>
          <div className="mt-2">contact@shopmarega.com</div>
          <div className="mt-6 text-xs text-gray-400">© {new Date().getFullYear()} shopmarega.com</div>
        </div>
      </div>
    </footer>
  );
}
